import date from 'date-fns';

export const toUTCDate = (value, negative) => {
  const timeZoneOffset = negative
    ? -new Date().getTimezoneOffset()
    : new Date().getTimezoneOffset();

  if (typeof value === 'string') {
    return date.addMinutes(new Date(value), timeZoneOffset);
  }

  return date.addMinutes(value, timeZoneOffset);
};

export const toUTCDateISOString = (value, negative) => {
  return toUTCDate(value, negative).toISOString();
};

export const toEndDate = date => {
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  return date;
};
